import { createSelector } from '@reduxjs/toolkit';

import every from 'lodash/fp/every';
import get from 'lodash/fp/get';
import getOr from 'lodash/fp/getOr';

import { accessoriesProducts, productsCategories } from 'constants/products';

import { createApiSelectors } from 'utils/reduxUtils';

const [getOrderData, , getOrderStatus] = createApiSelectors(get('singleOrder'));

export { getOrderData, getOrderStatus };

export const getOrderItems = createSelector(getOrderData, order => (order && order.items) || []);

export const getOrderCategory = createSelector(getOrderData, orderData => {
  if (!orderData) {
    return undefined;
  }
  return orderData.formulaset?.categories?.[0] ?? 'accessories';
});

export const getConfirmationOrderCategory = createSelector(
  getOrderData,
  getOr(productsCategories.HAIRCARE, 'formulaset.categories[0]')
);

export const getHasOnlyAccessoriesInOrderItems = createSelector(
  getOrderItems,
  every(item => accessoriesProducts.includes(item.variant.slug))
);

export const getIsCustomProductsOrder = createSelector(getOrderItems, items =>
  items.some(item => item.variant.is_formula)
);
